import { controls, currencyToNumber, grouped } from "../../controls";

const rpad15 = {
  label: "Inspecting Officer Checklist Total",
  starting: true,
  url: "rp101m",
  pageLabel: "Inspecting Officer Checklist Total",
  pageType: "history",
  visitingBranches: true,
  // filteraction: true,
  filter: [
  ],
  form: [],
  history: {
    perPage: 50,
    reportHeader: "Inspecting Officer Checklist",
    filterable: true,
    sortable: true,
    defaultsTo: 0,
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    textReportProps: {
      'Recon': {
        filename: `Auditor Checklist-$pageData.as_on_date$.txt`,
        format: {},
        separator: "|"
      },
    },

    displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
        width132: { size: 3 }
      },
      {
        Header: "Report Name",
        accessor: "display_name",
        rwidth: "*"
      },
      {
        Header: "Completed",
        accessor: "completed"
      },
      {
        Header: "Submitted",
        accessor: "total"
      }
    ]
  }
};

export default rpad15;